import { type ComponentProps } from 'react';

export default function MissionIcon ({ ...otherProps }: ComponentProps<'svg'>): JSX.Element {
  return (
    <svg fill='currentColor' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 29.95 36.47' {...otherProps}>
      <path d='M29.95,26.38l-14.98,10.09L0,26.38l5.5-3.71,9.47,6.38,9.47-6.38,5.5,3.71Zm-5.7-11.9l5.18,3.49-14.46,9.74L.52,17.97l5.23-3.52L.05,10.61,15.02,.52l14.98,10.09-5.75,3.87Zm3.44-3.87L15.02,2.07,2.35,10.61l12.67,8.54,12.67-8.54Z' />
    </svg>
  );
}
